/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.assignments.rpc.ContentAssignmentsChirpService
 */

export const assignContentRpc = {
  serviceName: 'com.hubspot.learning.center.assignments.rpc.ContentAssignmentsChirpService',
  rpcName: 'assignContent',
  auth: 'app',
  fingerprint: '8GmSCY-Da7VVnA9lNO7M30S3OizCaH0T',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getContentAssignmentsByIdsRpc = {
  serviceName: 'com.hubspot.learning.center.assignments.rpc.ContentAssignmentsChirpService',
  rpcName: 'getContentAssignmentsByIds',
  auth: 'app',
  fingerprint: '-lB1tfUgR3lVnA9lNO7M30S3OizCaH0T',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateContentAssignmentRpc = {
  serviceName: 'com.hubspot.learning.center.assignments.rpc.ContentAssignmentsChirpService',
  rpcName: 'updateContentAssignment',
  auth: 'app',
  fingerprint: 'p3XZwU3afbZVnA9lNO7M30S3OizCaH0T',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteContentAssignmentRpc = {
  serviceName: 'com.hubspot.learning.center.assignments.rpc.ContentAssignmentsChirpService',
  rpcName: 'deleteContentAssignment',
  auth: 'app',
  fingerprint: 'YqDqisGrOJNW9WdjwXobIkS3OizCaH0T',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const searchRpc = {
  serviceName: 'com.hubspot.learning.center.assignments.rpc.ContentAssignmentsChirpService',
  rpcName: 'search',
  auth: 'app',
  fingerprint: 'zGWnJPgXIF5jnqKMepUw9ES3OizCaH0T',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const searchAggregationRpc = {
  serviceName: 'com.hubspot.learning.center.assignments.rpc.ContentAssignmentsChirpService',
  rpcName: 'searchAggregation',
  auth: 'app',
  fingerprint: 'iXia4eRzPNiIpafuVE9QLUS3OizCaH0T',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};